import { TextAreaField } from "@/components/TextAreaField";
import { LIMITS } from "@/features/identity/validation";

export function AboutSection({ form }) {
  const { values, errors, onChange } = form;
  return (
    <TextAreaField
      id="about-bio"
      name="bio"
      label="Bio"
      optional
      rows={6}
      limit={LIMITS.bio}
      placeholder="What you do, who you do it for, and what you care about."
      testId="about-bio-input"
      value={values.bio}
      onChange={onChange}
      error={errors.bio}
    />
  );
}
